import { render, staticRenderFns } from "./CommentReplyTile.vue?vue&type=template&id=1f351d37&scoped=true&lang=pug&"
import script from "./CommentReplyTile.vue?vue&type=script&lang=js&"
export * from "./CommentReplyTile.vue?vue&type=script&lang=js&"
import style0 from "./CommentReplyTile.vue?vue&type=style&index=0&id=1f351d37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f351d37",
  null
  
)

export default component.exports